import api, { ResponsePayloadWithData } from '../../../api';

export type PaperType = 'lines' | 'raster' | 'media' | 'blank';

export type Whitepage = {
  id: string;
  title: string;
  paperType: PaperType;
  nodeId: string;
  updatedAt: string;
  createdAt: string;
};

export const getWhitepages = async (moduleId: string, nodeId: string) => {
  const { data } = await api.get<ResponsePayloadWithData<Whitepage[]>>(
    `/studio/user/modules/${moduleId}/table-of-content/${nodeId}/whitepages?noDescendants=true`,
  );

  return data;
};

export const getWhitepage = async (moduleId: string, nodeId: string, whitepageId: string) => {
  const { data } = await api.get<Whitepage & { pdfUrl: string }>(
    `/studio/user/modules/${moduleId}/table-of-content/${nodeId}/whitepages/${whitepageId}`,
  );

  return data;
};
